import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  fieldLabel: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: theme.spacing(0.5),
  },
}))

export default useStyles
